import React from "react";
import {findConsecutiveBrChildIndex, RichTextElement, RichTextProps} from "./CCORichTextHelper";

export interface ElementsToWrap {
    elementsToDisplay: RichTextElement[],
    elementsToWrap: RichTextElement[]
}

export function addShowMoreWrapperIfNecessary(props: RichTextProps,
                                              element: JSX.Element | null,
                                              childrenToWrap: ElementsToWrap,
                                              renderElement: (...args: any[]) => JSX.Element | null,
                                              showMore: boolean,
                                              setShowMore: (...args: any[]) => void): JSX.Element | null {
    const wrapper: RichTextElement = {
        "_type": "Element",
        name: "showMoreWrapper",
        children: [
            {
                "_type": "Element",
                children: childrenToWrap.elementsToDisplay

            } as RichTextElement,
            {
                "_type": "Element",
                children: childrenToWrap.elementsToWrap
            } as RichTextElement
        ]
    }
    const propCopy = Object.assign({}, props, {collapseOnDoubleBreak: false, textAsTree: wrapper});


    const wrapperElement = renderElement(propCopy, wrapper, undefined, props.variant, showMore, setShowMore)

    if (props.collapseOnDoubleBreak && childrenToWrap.elementsToWrap.length > 0) {
        return <React.Fragment key={props.textAsTree.uuid}>
            {element}
            {wrapperElement}
        </React.Fragment>
    }
    return element
}

/**
 * If the element is preceded by two consecutive br tags, wrap the element in a "Mehr erfahren" container
 * and return true to return inside the renderElement function and avoid double rendering
 */
export function wrapElementsAfterConsecutiveBrTagsInShowMoreAndReturn(props: RichTextProps,
                                                                      element: RichTextElement,
                                                                      childrenToWrap: ElementsToWrap): boolean {
    if (!element || !element.children || element.children.length === 0) {
        return false;
    }
    let consecutiveBrIndex = findConsecutiveBrChildIndex(element)
    if (props.collapseOnDoubleBreak && childrenToWrap && childrenToWrap.elementsToWrap.length > 0) {
        childrenToWrap.elementsToWrap.push(element)
        return true
    }
    if (consecutiveBrIndex && props.collapseOnDoubleBreak && childrenToWrap && childrenToWrap.elementsToWrap.length === 0) {
        if (element.children && typeof element.children[consecutiveBrIndex] !== 'undefined') {
            const elementsToDisplay: RichTextElement[] = element.children.slice(0, consecutiveBrIndex + 1)
            elementsToDisplay.forEach(element => childrenToWrap.elementsToDisplay.push(element))

            const elementsToWrap: RichTextElement[] = element.children.slice(consecutiveBrIndex + 2)
            elementsToWrap.forEach(element => childrenToWrap.elementsToWrap.push(element))
        }
        return true
    }
    return false
}